module.exports = __webpack_public_path__ + "static/media/about_us.9a4eecad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/about_us.jpg
// module id = 956
// module chunks = 0